<template>
  <div class="registration-fee-print">
    <table>
      <thead>
        <tr>
          <th>{{ $tc('general.n0') }}</th>
          <th>{{ $tc('club.club_name') }}</th>
          <th>Cena bez popusta</th>
          <th>Cena sa popustom</th>
          <th>Popust udruženja</th>
          <th style="text-align: right;">Ukupno</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(item, index) in data" :key="item.club.id">
          <td>{{ index + 1 }}.</td>
          <td>{{ item.club.name }}</td>
          <td>{{ item.priceWithoutDiscount || 0 }} RSD</td>
          <td>{{ item.priceWithDiscount || 0 }} RSD</td>
          <td>{{ getCostReduction(item.club) }}% ({{ item.priceWithoutDiscount - item.total }}RSD)</td>
          <td style="text-align: right;">{{ item.total || 0 }} RSD</td>
        </tr>
      </tbody>
    </table>

    <div class="fee-summary-row" style="line-height: 1.5; margin-top: 15px;">Cena bez popusta: <b>{{ priceOne }} RSD</b></div>
    <div v-if="!hasAnyClubDiscount" class="fee-summary-row" style="line-height: 1.5;">Cena sa popustom: <b>{{ priceTwo }} RSD</b></div>
    <div class="fee-summary-row" style="line-height: 1.5;">Ukupno: <b>{{ total }} RSD</b></div>
  </div>
</template>

<script>
import registrationFeeMixin from './registration-fee'

export default {
  mixins: [registrationFeeMixin],

  props: {
    tournament: {
      type: Object,
      default: null
    },
    competitors: {
      type: Array,
      default: null
    },
    teams: {
      type: Array,
      default: null
    }
  },

  computed: {
    clubs () {
      return this.tournament?.clubs || []
    },

    hasAnyClubDiscount () {
      return this.clubs.some(club => this.getCostReduction(club) > 0)
    },

    data () {
      return this.clubs.map(club => {
        const allClubData = [
          ...this.getClubCompetitors(club.id),
          ...this.getClubTeams(club.id).map(team => ({
            ...team,
            isTeam: true
          }))
        ]

        const priceWithoutDiscount = this.getPriceWithoutDiscount(allClubData)
        const hasClubDiscount = this.getCostReduction(club) > 0

        return {
          club,
          priceWithoutDiscount,
          priceWithDiscount: hasClubDiscount ? priceWithoutDiscount : this.getPriceWithDiscount(allClubData),
          total: this.getTotal(club, allClubData)
        }
      })
    },

    allData () {
      return [
        ...this.competitors,
        ...this.teams.map(item => ({
          ...item,
          isTeam: true
        }))
      ]
    },

    priceOne () {
      return this.allData.reduce((acc, item) => (item.isTeam ? this.getTeamPrice(item) : this.getPrice(item)) + acc, 0)
    },

    priceTwo () {
      return this.allData.reduce((acc, item) => (item.isTeam ? this.getTeamPrice(item, !this.hideDiscount) : this.getPrice(item, !this.hideDiscount)) + acc, 0)
    },

    total () {
      return this.allData.reduce(
        (acc, item) => {
          const deduction = this.getCostReduction(item.club)
          let itemPrice
          if (deduction) {
            const fullPrice = item.isTeam ? this.getTeamPrice(item, false) : this.getPrice(item, false)
            itemPrice = ((100 - deduction) / 100) * fullPrice
          } else {
            itemPrice = item.isTeam ? this.getTeamPrice(item, true) : this.getPrice(item, true)
          }
          return acc + itemPrice
        },
        0
      )
    }
  },

  methods: {

    getCostReduction (club) {
      const clubDeductions = this.tournament.clubDeductions || []
      return clubDeductions.find(d => parseInt(d.clubId) === parseInt(club.id))?.deduction || 0
    },

    getPriceWithoutDiscount (data) {
      return data.reduce((acc, item) => (item.isTeam ? this.getTeamPrice(item) : this.getPrice(item)) + acc, 0)
    },

    getPriceWithDiscount (data) {
      return data.reduce((acc, item) => (item.isTeam ? this.getTeamPrice(item, !this.hideDiscount) : this.getPrice(item, !this.hideDiscount)) + acc, 0)
    },

    getTotal (club, data) {
      const deduction = this.getCostReduction(club)
      if (deduction) {
        return ((100 - deduction) / 100) * this.getPriceWithoutDiscount(data)
      }
      return this.getPriceWithDiscount(data)
    },

    getClubCompetitors (clubId) {
      return this.competitors?.filter(competitor => parseInt(competitor.club?.id) === parseInt(clubId)) || []
    },

    getClubTeams (clubId) {
      return this.teams?.filter(team => parseInt(team.club?.id) === parseInt(clubId)) || []
    }

  }
}
</script>
